import React, { useEffect, useState } from "react";
import '../../CSS/Actualite.css';
import ArticleComponent from "../composant_reutilisable/ArticleComponent";

// const articlesData = [
//     {
//         id: 1,
//         link: "/article/569/benin-luxembourg-s-e-m-corinne-amori-brunet-presente-lettres-creance-altesse-royale-lieutenant-representant-grand-heritier",
//         date: "Comptes rendus 09 septembre 2025",
//         title: "Bénin – Luxembourg : S.E.M. Corinne Amori Brunet présente ses lettres de créance à Son Altesse Royale, le Lieutenant-Représentant le Grand-Duc Héritier",
//         image: "https://api.diplomatie.bj/upload/images//351490112447001757574232.png",
//         alt: "benin-luxembourg-s-e-m-corinne-amori-brunet-presente-lettres-creance-altesse-royale-lieutenant-representant-grand-heritier"
//     },
//     {
//         id: 2,
//         link: "/article/565/benin-serbie-premieres-consultations-politiques-cotonou-sous-conduite-ministre-olushegun-adjadi-bakari",
//         date: "Comptes rendus 01 septembre 2025",
//         title: "Bénin–Serbie : premières consultations politiques à Cotonou sous la conduite du Ministre Olushegun ADJADI BAKARI",
//         image: "https://api.diplomatie.bj/upload/images//253140327120001756744670.jpg",
//         alt: "benin-serbie-premieres-consultations-politiques-cotonou-sous-conduite-ministre-olushegun-adjadi-bakari"
//     },
//     {
//         id: 3,
//         link: "/article/564/entretien-bakari-barrot-diplomatie-action-valorisation-diaspora-beninoise",
//         date: "Comptes rendus 30 juillet 2025",
//         title: "Entretien Bakari-Barrot : Diplomatie d'action et valorisation de la diaspora béninoise",
//         image: "https://api.diplomatie.bj/upload/images//149830912116001756725533.jpg",
//         alt: "entretien-bakari-barrot-diplomatie-action-valorisation-diaspora-beninoise"
//     },
//     {
//         id: 4,
//         link: "/article/541/benin-italie-s-e-m-corinne-amori-brunet-presente-lettres-creance-president-sergio-mattarella",
//         date: "Comptes rendus 17 juillet 2025",
//         title: "Bénin–Italie : S.E.M. Corinne Amori Brunet présente ses lettres de créance au Président Sergio Mattarella",
//         image: "https://api.diplomatie.bj/upload/images//120740095781001756745506.jpg",
//         alt: "benin-italie-s-e-m-corinne-amori-brunet-presente-lettres-creance-president-sergio-mattarella"
//     },
//     {
//         id: 5,
//         link: "/article/543/benin-pays-s-e-m-corinne-amori-brunet-presente-lettres-creance-majeste-willem-alexander",
//         date: "Comptes rendus 02 juillet 2025",
//         title: "Benin-Pays-Bas : S.E.M. Corinne Amori Brunet présente ses Lettres de créance à Sa Majesté le Roi Willem-Alexander",
//         image: "https://api.diplomatie.bj/upload/images//647910574884001756747315.jpg",
//         alt: "benin-pays-s-e-m-corinne-amori-brunet-presente-lettres-creance-majeste-willem-alexander"
//     },
//     {
//         id: 6,
//         link: "/article/545/et-diaspora-etait-simple-soutien-mais-levier-transformation",
//         date: "Comptes rendus 20 juin 2025",
//         title: "Et si la diaspora n'était pas un simple soutien, mais un levier de transformation ?",
//         image: "https://api.diplomatie.bj/upload/images//410350660655001754668841.jpg",
//         alt: "et-diaspora-etait-simple-soutien-mais-levier-transformation"
//     },
//     {
//         id: 7,
//         link: "/article/527/le-benin-premier-pays-afrique-subsaharienne-rejoindre-programme-europeen-star-venture",
//         date: "Comptes rendus 05 juin 2025",
//         title: "Le Bénin, premier pays d'Afrique subsaharienne à rejoindre le programme européen Star Venture",
//         image: "https://api.diplomatie.bj/upload/images//016930275559001749108386.jpg",
//         alt: "le-benin-premier-pays-afrique-subsaharienne-rejoindre-programme-europeen-star-venture"
//     },
//     {
//         id: 8,
//         link: "/article/520/s-e-mme-corinne-amori-brunet-presente-lettres-creance-president-alexander-stubb",
//         date: "Comptes rendus 25 mai 2025",
//         title: "S.E.Mme Corinne Amori Brunet présente ses Lettres de créance au Président Alexander Stubb",
//         image: "https://api.diplomatie.bj/upload/images//609580701768001748160804.jpg",
//         alt: "s-e-mme-corinne-amori-brunet-presente-lettres-creance-president-alexander-stubb"
//     },
//     {
//         id: 9,
//         link: "/article/547/le-benin-confirme-place-dans-enjeux-internationaux-droits-humains",
//         date: "Comptes rendus 20 mai 2025",
//         title: "Le Bénin confirme sa place dans les enjeux internationaux des droits humains",
//         image: "https://api.diplomatie.bj/upload/images//182030645400001754734253.jpg",
//         alt: "le-benin-confirme-place-dans-enjeux-internationaux-droits-humains"
//     },
//     {
//         id: 10,
//         link: "/article/566/luxembourg-benin-ministre-etat-romuald-wadagni-conduit-commission-partenariat",
//         date: "Comptes rendus 16 mai 2025",
//         title: "Luxembourg–Bénin : le Ministre d'État Romuald WADAGNI conduit la 2e Commission de partenariat",
//         image: "https://api.diplomatie.bj/upload/images//270510000296001756748444.jpg",
//         alt: "luxembourg-benin-ministre-etat-romuald-wadagni-conduit-commission-partenariat"
//     }
// ];

const Compte_rendus = () => {
const [communiques, setCommuniques] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1); // page actuelle
  const [pagination, setPagination] = useState({
    current_page: 1,
    total_items: 0,
    items_per_page: 10,
    total_pages: 1,
  });

  const fetchCommuniques = async (pageNumber = 1) => {
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/embassy/articles?page=${pageNumber}`,
        {
          method: "GET",
          headers: { "code-ambassade": "uuidARBF0A1" },
        }
      );

      if (!response.ok) throw new Error("Erreur réseau");

      const data = await response.json();
      console.log("🔍 Données API:", data);

      if (data?.data) {

        // Filtrer seulement les articles de la catégorie "Communiqués"
        const communiques = data.data.filter(
          (a) => a.articleCategory === "Comptes rendus"
        );

        const formattedArticles = communiques.map((a) => ({
          id: a.id,
          link: a.url || `/article/${a.id}/${a.slug}`,
          date: `${a.articleCategory} ${new Date(a.date.date).toLocaleDateString(
            "fr-FR",
            { day: "2-digit", month: "long", year: "numeric" }
          )}`,
          title: a.title,
          image: a.banner
            ? a.banner.replace(/([^:]\/)\/+/g, "$1")
            : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR8bikI-KUuM1IWosgqDRS5jyv2U_PPYlG6Tg&s",
          alt: a.slug,
        }));

        setCommuniques(formattedArticles);
        setPagination(data.pagination); // ⚡️ important
      }
    } catch (error) {
      console.error("Erreur de chargement :", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCommuniques(page);
  }, [page]);

  const goToPage = (num) => setPage(num);
  const prevPage = () => page > 1 && setPage(page - 1);
  const nextPage = () => page < pagination.total_pages && setPage(page + 1);

  // Génération dynamique des numéros de page
  const renderPageNumbers = () => {
    const pages = [];
    for (let i = 1; i <= pagination.total_pages; i++) {
      pages.push(
        <li key={i} className={`list ${i === page ? " warning" : ""}`}>
          <a
            className={`vt-5-in hz-20-in border ${i === page ? "pointer-events-none" : "pointer"
              }`}
            onClick={() => goToPage(i)}
          >
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };


  return (
    <div className="actualite-container">
      <div className="actualite-content">
        {loading ? (
          <p style={{ textAlign: "center" }}>Chargement des comptes rendus...</p>
        ) : communiques.length === 0 ? (
          <p style={{ textAlign: "center" }}>Aucun compte rendu disponible</p>
        ) : (
          <>
            <ArticleComponent articles={communiques} />

            {/* Pagination dynamique */}
            <div className="pagination">
              {/* Bouton Précédent — seulement si page > 1 */}
              {page > 1 && (
                <li className="list">
                  <a
                    className={`vt-5-in hz-5-in border ${page === 1 ? "pointer-events-none" : "pointer"}`}
                    onClick={prevPage}
                  >
                    ← Précédent
                  </a>
                </li>
              )}

              {renderPageNumbers()}

              {/* Bouton Suivant — seulement si page < total_pages */}
              {page < pagination.total_pages && (
                <li className="list">
                  <a
                    className={`vt-5-in hz-5-in border ${page === pagination.total_pages ? "pointer-events-none" : "pointer"}`}
                    onClick={nextPage}
                  >
                    Suivant →
                  </a>
                </li>
              )}
            </div>


            <p className="text-center mt-3">
              Page {page} sur {pagination.total_pages} — {pagination.total_items} résultats
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default Compte_rendus;